import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col" data-id="element-35">
      <Navbar data-id="element-36" />
      <main className="flex-grow" data-id="element-37">{children}</main>
      <Footer data-id="element-38" />
    </div>;
}